// Button.jsx
import React from 'react';
import '../styles/tokens.css';
import '../styles/Button.css';
import { Link } from 'react-router-dom';

export const Button = ({
  variant = 'primary', // primary, secondary, brand, ghost, link
  size = 'md', // sm, md, lg
  className = '',
  children,
  startIcon,
  endIcon,
  to, // if URL prop is provided, render Link
  href, // if href provided, render a tag
  onClick,
  disabled,
  ...props
}) => {
  const classes = [
    'ds-btn',
    `ds-btn-${size}`,
    `ds-btn-${variant}`,
    className,
  ].filter(Boolean).join(' ');

  const content = (
    <>
      {startIcon && <span className="start-icon base-flex">{startIcon}</span>}
      {children}
      {endIcon && <span className="end-icon base-flex">{endIcon}</span>}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} aria-disabled={disabled} {...props}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} aria-disabled={disabled} {...props}>
        {content}
      </a>
    );
  }

  return (
    <button className={classes} onClick={onClick} disabled={disabled} {...props}>
      {content}
    </button>
  );
};
